export default __webpack_public_path__ + "static/media/pic23.1cbb1887.jpg";